import { Logo } from '@color/continuum';

import { LogoLink } from './LogoLink';

interface Props {
  externalLink?: string;
}

/**
 * This renders the Color logo, wrapped in a customizable link.
 *
 * We optionally render any content beneath the logo itself
 */
export const NavBarLogoLink: React.FC<Props> = ({ externalLink }) => {
  return (
    <LogoLink externalLink={externalLink}>
      <Logo variant="colorWordmark" color="dark" colorVariant="default" alt="Color logo" />
    </LogoLink>
  );
};
